import type { CSSProperties } from "react"

// Palette et surfaces de la section Nutrition (maquette Claude Design « Nutrition v2 »).
// Le violet est propre à la Nutrition ; le cyan reste l'accent du reste de l'app.
export const NUTRITION_VIOLET = "#8b5cf6"

// Couleurs des macros, identiques sur Apport énergétique et Semaine type.
export const MACRO_COLORS = {
  protein: "#a78bfa",
  carbs: "#f59e0b",
  fat: "#2dd4bf",
} as const

export const CARD = "rounded-2xl border border-white/[0.06] bg-[#0c1120]/85"

// Carte cliquable sur toute sa surface.
export const CARD_PRESSABLE = "cursor-pointer transition-all hover:border-white/[0.12] active:scale-[0.98]"

// Carte « hero » : fond sombre avec halo violet ; `at` place le centre du halo (syntaxe radial-gradient).
export function haloSurface(at: string): CSSProperties {
  return {
    background: `radial-gradient(80% 70% at ${at}, rgba(139,92,246,0.24), rgba(139,92,246,0) 70%), linear-gradient(180deg, #121529, #0b0f1d)`,
    borderColor: "rgba(139,92,246,0.2)",
  }
}
